export default ".dialog-modal{display:block}.modal-body p{margin:0}";